import { useEffect, useState } from "react";
import Cal, { getCalApi } from "@calcom/embed-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Sparkles } from "lucide-react";

const CAL_HANDLE = process.env.REACT_APP_CALCOM_LINK || "";

export default function CalBookingDialog({ open, onOpenChange }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!open || !CAL_HANDLE) return;
    let cancelled = false;
    (async () => {
      try {
        const cal = await getCalApi({ namespace: "saas-demo" });
        if (cancelled) return;
        cal("ui", {
          theme: "light",
          hideEventTypeDetails: false,
          layout: "month_view",
          styles: { branding: { brandColor: "#0A2540" } },
          cssVarsPerTheme: {
            light: { "cal-brand": "#0A2540" },
          },
        });
        setReady(true);
      } catch (e) {
        // graceful fallback — show error inside dialog
        // eslint-disable-next-line no-console
        console.warn("Cal.com embed failed:", e);
        setReady(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="cal-booking-dialog"
        className="sm:max-w-3xl bg-[#FAF9F6] border-[#0A2540]/15 p-0 overflow-hidden"
      >
        <div className="absolute top-0 inset-x-0 h-[3px] bg-gradient-to-r from-transparent via-[#C9A961] to-transparent" />
        <DialogHeader className="px-8 pt-8 pb-3">
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.22em] text-[#C9A961]">
            <Sparkles className="h-3.5 w-3.5" />
            MedAdmits · Calendar
          </div>
          <DialogTitle className="font-serif-display text-3xl text-[#0A2540] mt-3 leading-tight">
            Pick a slot — <em className="text-[#C9A961]">it's yours</em>.
          </DialogTitle>
          <DialogDescription className="text-[#0A2540]/65 text-sm">
            30-minute walkthrough · custom-branded sandbox shown live.
          </DialogDescription>
        </DialogHeader>

        <div className="px-2 pb-2">
          {!CAL_HANDLE ? (
            <div className="m-6 rounded-lg border border-[#C9A961]/30 bg-[#C9A961]/8 p-6 text-sm text-[#0A2540]/75">
              <strong className="text-[#0A2540]">Calendar not configured yet.</strong>
              <p className="mt-2">
                The team will reach out manually within 1 business day. To enable
                self-serve booking, set <code className="bg-white px-1.5 py-0.5 rounded text-xs">REACT_APP_CALCOM_LINK</code>{" "}
                in <code className="bg-white px-1.5 py-0.5 rounded text-xs">frontend/.env</code>.
              </p>
            </div>
          ) : (
            <div
              className="rounded-xl overflow-hidden bg-white border border-[#0A2540]/8"
              style={{ height: "640px" }}
            >
              {ready && (
                <Cal
                  namespace="saas-demo"
                  calLink={CAL_HANDLE}
                  style={{ width: "100%", height: "100%", overflow: "scroll" }}
                  config={{ layout: "month_view", theme: "light" }}
                />
              )}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
